/* eslint-disable import/no-unresolved */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Box, Typography } from '@material-ui/core';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Drawer from '@material-ui/core/Drawer';


import style from './style';
import { Button } from '@mui/material';
import { makeStyles } from '@material-ui/styles';
import Suggest_Bid from '../../pages/Suggest_Bid/Suggest_Bid';
import EditPost from '../../pages/Editpost/EditPost';
import Mobile_Browser_Market1 from '../../pages/Mobile_Browser_Market1/Mobile_Browser_Market1';

const DialogItemAtom = (props) => {

  const classes = useStyles();
  const [openSuggest, setOpenSuggest] = useState(false);
  const [openNewDeal, setOpenNewDeal] = useState(false);
  const [openLogin, setOpenLogin] = useState(false);


  const handleClose = () => {
    props.onClose(false);
  };


  return (
    <>
      <Dialog onClose={handleClose} open={props.open}>
        {/* <DialogTitle>Set backup account</DialogTitle> */}
        <List>
          <ListItem>
            <Button
              // name="बोली दर्ज करें"
              onClick={() => {
                props.onClose(false);
                setTimeout(() => {
                  setOpenSuggest(true);
                }, 400)

              }}
              style={{
                borderRadius: "5px",
                boxShadow: "0 3px 6px 0 rgba(255, 255, 255, 0.58)",
                border: "solid 1px #53252f",
                backgroundColor: "#53252f",
                color: "white",
                padding: "5px 20px",
                fontSize: 16,
                width: "200px"
              }}
            >
              बोली दर्ज करें
            </Button>
          </ListItem>
          {props.loggedIn ?
            <ListItem>
              <Button
                // name="बोली दर्ज करें"
                onClick={() => {
                  props.onClose(false);
                  setTimeout(() => {
                    setOpenNewDeal(true);
                  }, 400)

                }}
                style={{
                  borderRadius: "5px",
                  boxShadow: "0 3px 6px 0 rgba(255, 255, 255, 0.58)",
                  border: "solid 1px #53252f",
                  backgroundColor: "#53252f",
                  color: "white",
                  padding: "5px 20px",
                  fontSize: 16,
                  width: "200px"
                }}
              >
                नया सौदा बनाएं
              </Button>
            </ListItem>
            : <></>
          }

        </List>
      </Dialog>
      <React.Fragment>
        <Drawer className={classes.drawerDesign} anchor={'bottom'} open={openSuggest}>
          <Suggest_Bid PhoneNo={props.PhoneNo} closePopUp={setOpenSuggest} link={props.link} methodFlag={props.methodFlag} dealId={props.dealId} quantityUnit={props.quantityUnit} loggedIn={props.loggedIn} selectedDeal={props.selectedDeal} date={props.date} />
        </Drawer>
      </React.Fragment>

      <React.Fragment>
        <Drawer className={classes.drawerDesign} anchor={'bottom'} open={openNewDeal}>
          <EditPost closePopUp={setOpenNewDeal} dealId={props.selectedDeal} date={props.date} />
        </Drawer>
      </React.Fragment>
      <React.Fragment>
        <Drawer className={classes.drawerDesign} anchor={'bottom'} open={openLogin}>
          <Mobile_Browser_Market1 PhoneNo={props.PhoneNo} closePopUp={setOpenNewDeal} link={props.link} methodFlag={"edit"} dealId={props.dealId} quantityUnit={props.quantityUnit} loggedIn={props.loggedIn} />
        </Drawer>
      </React.Fragment>
    </>

  );
}

const useStyles = makeStyles(() => ({
  drawerDesign: {
    '& .MuiDrawer-paper': {
      paddingTop: 20,
      margin: "auto",
      maxWidth: 540,
      borderRadius: '20px 20px 0 0',
    }
  },
  headerBrowser: {
    background: '#53252f',
    color: '#fff',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px 20px',
    boxSizing: 'border-box',
    alignItems: 'center',
  },
  kishanDetail: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px 20px',
    boxSizing: 'border-box',
    alignItems: 'center',
  },
  textCenterSet: {
    display: 'flex',
    alignItems: 'center',
  },
  rotateSHareIcon: {
    transform: 'rotateY(360deg)',
  },
  contetnArrange: {
    width: '100%',
    padding: '10px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    '& div': {
      width: '100%'
    }
  },
  commonSectionBuild: {
    maxWidth: 540,
    float: 'none',
    margin: '0 auto'
  },
  manageIconCenter: {
    justifyContent: 'center',
    padding: '50px 0 20px',
    boxSizing: 'border-box',
  },
  image: {
    width: '35px',
    height: '35px',
    borderRadius: '50%',
    position: 'relative',
    overflow: 'hidden',
  },
  footerFixed: {
    position: 'fixed',
  },
  dealerCall: {
    width: '55%',
    padding: '10px 20px',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '200px',
    marginLeft: '60px',
  },
}));

export default DialogItemAtom;